import React from 'react'
import { Route, Switch } from "react-router-dom";
import DangKyNgayNghi from "components/dang-ky-ngay-nghi";
import KhaiBaoCongTac from "components/khai-bao-cong-tac";
import PageNotFound from "components/page-not-found";
import QuanLyNgayNghi from 'components/quan-ly-ngay-nghi';
import QuanLyCongTac from 'components/quan-ly-cong-tac';
import QuanLyUsers from 'components/quan-ly-users';
import QuanLyNgayPhep from 'components/quan-ly-ngay-phep';
import KhaiBaoViecLamONha from '../components/khai-bao-viec-lam-o-nha/index';
import QuanLyLamViecONha from '../components/quan-ly-viec-lam-o-nha/index';

const routes = [
  {
    path: '/',
    exact: true
  },
  {
    path: '/dangkyngaynghi',
    component: DangKyNgayNghi
  },
  {
    path: '/khaibaocongtac',
    component: KhaiBaoCongTac
  },
  {
    path: '/khaobaovieclam',
    component: KhaiBaoViecLamONha
  },
  {
    path: '/quanlyngaynghi',
    component: QuanLyNgayNghi
  },
  {
    path: '/quanlycongtac',
    component: QuanLyCongTac
  },
  {
    path: '/quanlyngayphep',
    component: QuanLyNgayPhep
  },
  {
    path: '/users',
    component: QuanLyUsers
  },
  {
    path: '/quanlylamvieconha',
    component: QuanLyLamViecONha
  },
  {
    path: '*',
    component: PageNotFound
  }
]

const Routes = () => {
  return (
    <Switch>
      {routes.map((route, idx) =>
        <Route key={idx} path={route.path} component={route.component} exact={route.exact} />
      )}
    </Switch>
  )
}
export default Routes


// WEBPACK FOOTER //
// ./src/routes/routes.jsx